export enum OrderDeclineType {
  Retryable = 'retryable',
  Final = 'final',
  MethodFinal = 'method_final',
  InsufficientFunds = 'insufficient_funds',
  Fraud = 'fraud',
}
